import React, { Component } from 'react';
import moment from 'moment';

import TimeoutSignsSettingsForm from './TimeoutSignsSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import TimeoutSignsModel from './TimeoutSignsModel';
import UserModel from './UserModel';

import { Table, Badge, Menu, Divider, Row, Col, Statistic, Popconfirm, Typography, message, Tag, Tooltip } from 'antd';

class TimeoutSignsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    timeoutSignsSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
        <Col span={6}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Z. šířka"
              value={record.coords.coordinates[1]} />
        </Col>
        <Col span={6}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Z. výška"
              value={record.coords.coordinates[0]} />
        </Col>
        <Col span={8}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Poslední komunikace do značky"
              value={moment(record.lastCommunication).format('L LTS')} />
          </Col>
          <Col span={24}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Událost"
              value={record.eventListener} />
          </Col>

        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'TimerName',
      dataIndex: 'timerName',
      key: 'timerName',
      width: 120,
      sorter: (a, b) => defaultSorter(a.timerName, b.timerName),
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastStateChanged',
      key: 'lastStateChanged',
      width: 200,
      sorter: (a, b) => dateSorter(a.lastStateChanged, b.lastStateChanged),
      render: (text, record) => {
        return (
          moment(record.lastStateChanged).format('L LTS')
          )
      }
    }, {
      title: 'Stav',
      dataIndex: 'occState',
      key: 'occState',
      width: 130,
      sorter: (a, b) => defaultSorter(a.occState, b.occState),
      render: (text, record) => {
        if (record.occState === 1) {
          return (
            <Badge
              status="error"
              text={"OBSAZENO"}
              title="Obsazeno" />
          );
        } else if (record.occState === 0) {
          return (
            <Badge
              status="success"
              text={"VOLNO"}
              title="Volno" />
          );
        } else {
          return (
            <Badge
              color="#6d6d6d"
              text={"Kalibrace / neznámý stav / chyba "}
              title="Kalibrace / neznámý stav / chyba" />
          )
        }
      }
    }, {
      title: 'Nastavený limit (min)',
      dataIndex: 'timeLimit',
      key: 'timeLimit',
      width: 130,
      sorter: (a, b) => defaultSorter(a.timeLimit, b.timeLimit),
    }, {
      title: 'Zobrazený text',
      dataIndex: 'displayedString',
      key: 'displayedString',
      width: 130,
      render: (text, record) => {
        if (record.displayedString == '--') {
          return (
            <Tooltip title="Zhasnutá cedule"><Tag color='black'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Tag></Tooltip>
          )
        } else {
          if (record.displayedString >= 0) {
            return (
              <Tooltip title="Povolené parkování"><Tag color="green">{record.displayedString}</Tag></Tooltip>
            )
          } else {
            return (
              <Tooltip title="Parkování přes limit"><Tag color="red">{Math.abs(parseInt(record.displayedString))}</Tag></Tooltip>
            )
          }
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 300,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'TIMEOUTSIGNS_WRITE'])) {
          return (
            <div>
              <Divider type="vertical" />
              <a onClick={(e) => {
                this.setState({
                  timeoutSignsSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm
                placement="right"
                title="Opravdu si přejete tuto tabuli smazat?"
                okText="Ano"
                cancelText="Ne"
                onConfirm={() => {
                  TimeoutSignsModel.remove(record.id)
                    .then(() => {
                      message.success('Informační tabule byla odstraněna!');
                      this.props.onRowRemoved();
                    })
                    .catch(() => {
                      message.error('Informační tabuli se nepodařilo smazat!');
                    });
                }}>
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          onChange={this.handleChange}
          expandedRowRender={this.expandedRowRender.bind(this)}
          rowSelection={
            this.props.rowSelection !== undefined
              ? this.props.rowSelection
              : null
          }
        />

        <TimeoutSignsSettingsForm
          type="modal"
          modalVisible={this.state.timeoutSignsSettingsFormData === null ? false : true}
          initialValues={this.state.timeoutSignsSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ timeoutSignsSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            TimeoutSignsModel.update(this.state.timeoutSignsSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  timeoutSignsSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default TimeoutSignsTable;


// WEBPACK FOOTER //
// ./src/components/TimeoutSignsTable.js